import styled, { css } from 'styled-components';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/faq/faq_shadow.png';

const StyledShadow = styled.div`
	position: absolute;
	width: 900px;
	height: 910px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	pointer-events: none;
`;

const StyledShadowTop = styled(StyledShadow)`
	top: -350px;
	left: -355px;
`;

const StyledShadowBottom = styled(StyledShadow)`
	bottom: -450px;
	right: -455px;
`;

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
	height: 899px;
	margin-top: 20px;
	padding: 20px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;
`;

const StyledArrowContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		width: 10px;
		height: 10px;
		transition:
			transform 0.3s ease,
			filter 0.3s ease;
		user-select: none;
		pointer-events: none;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledMenuHeadingTop = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 60px;
	padding: 0 20px;
	cursor: pointer;

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledMenuHeading = styled.div<{ $active?: boolean }>`
	position: relative;

	${(props) =>
		props.$active &&
		css`
			${StyledMenuHeadingTop} {
				${StyledArrowContainer} {
					img {
						transform: rotate(180deg);
					}
				}
			}
		`}
`;

const StyledMenuItemsContainer = styled.div<{
	$isOpen: boolean;
	$height: number;
}>`
	max-height: ${(props) => (props.$isOpen ? `${props.$height}px` : 0)};
	overflow: hidden;
	transition: max-height 0.3s ease;

	& > div {
		display: flex;
		flex-direction: column;
		gap: 10px;
		padding: 20px;
	}
`;

const StyledMenuItem = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	height: 50px;
	padding: 0 20px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	${Text} {
		font-weight: 400;
		font-size: 14px;
		color: #ffffff;
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
		transition:
			color 0.3s ease,
			opacity 0.3s ease;
	}

	img {
		opacity: 0;
		transition: opacity 0.3s ease;
		user-select: none;
		pointer-events: none;
	}

	&:hover {
		${Text} {
			opacity: 1;
			color: #000000;
		}

		background-color: #ffffff;
	}
`;

const StyledSection = styled.div`
	border-radius: 5px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	overflow: hidden;

	${Divider} {
		width: calc(100% - 40px);
		margin: 0 20px;
	}
`;

const StyledSupportButtonContainer = styled.div`
	position: absolute;
	left: 20px;
	right: 20px;
	bottom: 20px;
`;

const StyledSupportButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;

	${Text} {
		font-size: 16px;
	}

	img {
		width: 20px;
		height: 20px;
		filter: invert(100%);
	}
`;

export {
	StyledArrowContainer,
	StyledContainer,
	StyledMenuHeading,
	StyledMenuHeadingTop,
	StyledMenuItem,
	StyledMenuItemsContainer,
	StyledSection,
	StyledShadowBottom,
	StyledShadowTop,
	StyledSupportButtonContainer,
	StyledSupportButtonContent,
};
